export default {
    container: '',
    itemsTree: [],
};
